import { render, staticRenderFns } from "./QuestionnaireGroupForm.vue?vue&type=template&id=48c3906f"
import script from "./QuestionnaireGroupForm.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireGroupForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports